import React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import tileTexture from 'src/assets/legislativeBodies/tiles.jpg';

import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { DecisionMakerCard } from './components/DecisionMakerCard';
import { LegislativeBodyCard } from './components/LegislativeBodyCard';
import { ViewAll } from './components/ViewAll';
import { useLegislativeBodiesContainer } from './hooks/useLegislativeBodiesContainer';
import { useTracking } from './hooks/useTracking';

export const LegislativeBodiesContainer: React.FC = () => {
	const { trackTooltipClick } = useTracking();
	const { translate } = useI18n();

	const {
		data: { dmsAndLBs, displayViewAllButton, totalDmCount },
	} = useLegislativeBodiesContainer();

	return (
		<div className="bg-gradient-background-light-3 md:rounded-large relative px-6 py-10">
			<div
				className="md:rounded-large absolute inset-0 bg-repeat opacity-50"
				style={{
					backgroundImage: `url(${tileTexture})`,
				}}
			/>
			<div className="relative z-1 flex flex-col gap-6">
				<div className="flex gap-2">
					<Text variant="heading" as="h2" className="text-3xl">
						<Translate value="corgi.petition_gamma.decision_makers_v2.section_title" />
					</Text>
					<InfoTooltip
						aria-label={translate('corgi.petition_gamma.decision_makers_v2.tooltip_label')}
						data-qa="dm-section-tooltip"
						onClick={trackTooltipClick}
						className="my-auto"
					>
						<Translate value="corgi.petition_gamma.decision_makers_v2.tooltip" />
					</InfoTooltip>
				</div>
				{dmsAndLBs.map((item) =>
					item.type === 'legislative_body' ? (
						<div key={item.displayedDMs[0].id}>
							<LegislativeBodyCard legislativeBody={item} />
						</div>
					) : (
						<div key={item.displayedDMs[0].id}>
							<DecisionMakerCard dm={item.displayedDMs[0]} />
						</div>
					),
				)}

				{displayViewAllButton && <ViewAll totalDmCount={totalDmCount} />}
			</div>
		</div>
	);
};
